const errorList = {
  // Generic HTTP requests
  requestFailed: 'HTTP request failed.',
  graphqlRequestFailed: 'GraphQL request failed.',
  // Vehicle
  noDrilldown: 'No options generated for YMM.',
  noVehiclePrice: 'Vehicle price not computed.',
  offerNotDisplayed: 'Vehicle offer not displayed.',
  plateNotParsed: 'Unable to retrieve license plate.',
  vehiclePhotoFailed: 'Vehicle photo not fetched.',
  vinNotFound: 'Unable to retrieve VIN.',
  vehicleNotAdded: 'Vehicle failed to save.',
  // App
  containerNodeMissing:
    'Widget failed to load. Please set the ID  on the <div/> mount element.',
  unhandledError: 'Something went wrong.',
  duplicateScript:
    'Widget is loaded multiple times. Please remove duplicate <script/> tags.',
  attributesFetchFailed: 'Failed to fetch attributes.',
  sessionStorageSaveFailed: 'Failed to save to session storage.',
  sessionStorageGetFailed: 'Failed to get from session storage.',
  missingStore:
    'Failed to fetch store. Unable to proceed with tool initialization.',
  // SMS and Email
  smsNotSent: 'SMS not sent.',
};

type ErrorListKeys = keyof typeof errorList;
type Errors = {
  [K in ErrorListKeys]: { code: K; message: string };
};

export const errors = Object.entries(errorList).reduce<Errors>(
  (obj, [errorCode, errorMessage]) => ({
    ...obj,
    [errorCode]: {
      code: errorCode,
      message: errorMessage,
    },
  }),
  {} as Errors
);
